import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AddUserIcon = createIcon({
    viewBox: '31.5 28.8 41 41',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M50.0613 53.09C51.9213 53.09 53.9612 53.36 56.1813 53.9C58.7013 54.53 60.7412 55.37 62.3013 56.42C64.1613 57.65 65.0913 59.03 65.0913 60.56V64.34H35.0312V60.56C35.0312 59.03 35.9612 57.65 37.8212 56.42C39.3813 55.37 41.4212 54.53 43.9412 53.9C46.1613 53.36 48.2012 53.09 50.0613 53.09ZM50.0613 49.31C48.7112 49.31 47.4663 48.9725 46.3263 48.2975C45.1862 47.6225 44.2788 46.715 43.6037 45.575C42.9287 44.435 42.5913 43.19 42.5913 41.84C42.5913 40.49 42.9287 39.23 43.6037 38.06C44.2788 36.89 45.1862 35.9675 46.3263 35.2925C47.4663 34.6175 48.7112 34.28 50.0613 34.28C51.4113 34.28 52.6562 34.6175 53.7962 35.2925C54.9363 35.9675 55.8437 36.89 56.5188 38.06C57.1938 39.23 57.5312 40.49 57.5312 41.84C57.5312 43.19 57.1938 44.435 56.5188 45.575C55.8437 46.715 54.9363 47.6225 53.7962 48.2975C52.6562 48.9725 51.4113 49.31 50.0613 49.31Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M68.9112 49.2434H64.7445V53.4101H63.3778V49.2434H59.2112V47.8767H63.3778V43.7101H64.7445V47.8767H68.9112V49.2434Z'
                fill='currentColor'
            />
        </>
    ),
})

AddUserIcon.displayName = 'AddUserIcon'
